<div class="page-404">
  <section class="st-content">
    <div class="container">
      <div class="row content-row" style="text-align: center;">
        <img style="height: 90vh; width: auto; margin: auto;" src="./assets/img/notice-layout.png">
      </div>
    </div>
  </section>
</div>